import { createContext, PropsWithChildren, useContext } from 'react'
import { UsePregnancyClinicalRationales } from './hooks'

export const PregnancyClinicalRationalesContext = createContext<UsePregnancyClinicalRationales>({
  data: null,
  loading: false,
  ref: null,
  rationales: [],
  handleUpdateCategoryName: async () => ({ error: 'Out of PregnancyClinicalRationalesContext' }),
  handleUpdateCategoryKeywords: async () => ({
    error: 'Out of PregnancyClinicalRationalesContext',
  }),
  handleUpdateCategoryRationale: async () => ({
    error: 'Out of PregnancyClinicalRationalesContext',
  }),
  handleDeleteCategory: async () => ({ error: 'Out of PregnancyClinicalRationalesContext' }),
  handleAddCategory: async () => ({ error: 'Out of PregnancyClinicalRationalesContext' }),
  handleDragEnd: () => {},
})

export const usePregnancyClinicalRationales = () => useContext(PregnancyClinicalRationalesContext)

export const PregnancyClinicalRationalesProvider = ({ children }: PropsWithChildren) => {
  const value = usePregnancyClinicalRationales()
  return (
    <PregnancyClinicalRationalesContext.Provider value={value}>
      {children}
    </PregnancyClinicalRationalesContext.Provider>
  )
}
